<template>
  <div class="error-message">
    <alert-circle class="error-message-icon" :size="28" />
    <div class="error-message-description">{{message}}</div>
  </div>
</template>

<style lang="sass" scoped>
.error-message
  text-align: center
  margin-top: 20px

.error-message-icon
  color: #FF0000

.error-message-description
  font-size: 14px
  color: #e60303
  word-wrap: break-word

.error-message-description.tfErrorText
  color: #f2171c
</style>

<script>
import AlertCircle from 'vue-material-design-icons/AlertCircle.vue'
import { mapState } from 'pinia'
import { useWidgetStore } from '@/store'
export default {
  name: 'ErrorMessage',
  props: {
    message: {
      type: String,
      default: null
    }
  },
  components: {
    AlertCircle
  }
}
</script>
